(function () {
  const CONTACT_FOR_QUOTE =
    window.searchaniseStrings?.contactForQuote || 'Contact for pricing';
  const ZERO_PRICE_PATTERN = /\$0(\.00)?/;
  const PLACEHOLDER_PRICE_PATTERN = /\$99,999(\.00)?/;

  function getPriceText(priceEl) {
    const clone = priceEl.cloneNode(true);
    clone.querySelectorAll('.snize-highlight-saving-text').forEach((node) => node.remove());
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function shouldShowContactForPricing(productEl, priceEl) {
    if (productEl?.classList.contains('snize-product-tag-unpriced')) {
      return true;
    }

    const priceText = getPriceText(priceEl);
    return ZERO_PRICE_PATTERN.test(priceText) || PLACEHOLDER_PRICE_PATTERN.test(priceText);
  }

  function setQuotePrice(priceEl) {
    const savingHtml = priceEl.querySelector('.snize-highlight-saving-text')?.outerHTML || '';
    priceEl.innerHTML = CONTACT_FOR_QUOTE + savingHtml;
    priceEl.dataset.contactForQuoteApplied = 'true';
    priceEl.classList.add('snize-price--contact-for-quote');
  }

  function replaceZeroPrices() {
    document.querySelectorAll('.snize-product').forEach((productEl) => {
      const priceEl = productEl.querySelector('.snize-price');
      if (!priceEl) {
        return;
      }

      if (!shouldShowContactForPricing(productEl, priceEl)) {
        return;
      }

      if (
        priceEl.dataset.contactForQuoteApplied === 'true' &&
        !ZERO_PRICE_PATTERN.test(getPriceText(priceEl)) &&
        !PLACEHOLDER_PRICE_PATTERN.test(getPriceText(priceEl))
      ) {
        return;
      }

      setQuotePrice(priceEl);
    });
  }

  let debounceTimer;
  let resultsObserver;

  function scheduleReplace() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(replaceZeroPrices, 0);
  }

  function scheduleReplaceWithRetries() {
    scheduleReplace();
    window.setTimeout(replaceZeroPrices, 100);
    window.setTimeout(replaceZeroPrices, 350);
    window.setTimeout(replaceZeroPrices, 800);
  }

  function bindSearchaniseEvents() {
    document.addEventListener('Searchanise.ResultsUpdated', scheduleReplaceWithRetries);
    document.addEventListener('Searchanise.AutocompleteUpdated', scheduleReplaceWithRetries);
    document.addEventListener('Searchanise.DataRequestEnd', scheduleReplaceWithRetries);

    if (window.Searchanise?.$) {
      const $ = window.Searchanise.$;
      $(document).on('Searchanise.ResultsUpdated', scheduleReplaceWithRetries);
      $(document).on('Searchanise.AutocompleteUpdated', scheduleReplaceWithRetries);
      $(document).on('Searchanise.DataRequestEnd', scheduleReplaceWithRetries);
    }
  }

  function observeResultsContainer() {
    const resultsRoot = document.getElementById('snize_results');
    if (!resultsRoot || resultsObserver) {
      return;
    }

    resultsObserver = new MutationObserver(scheduleReplace);
    resultsObserver.observe(resultsRoot, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function init() {
    replaceZeroPrices();
    observeResultsContainer();
    bindSearchaniseEvents();
    scheduleReplaceWithRetries();
  }

  document.addEventListener('Searchanise.Loaded', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
